<template>
    <div class="my-profile-wrapper billing-wrapper">
        <div class="my-profile-card plan-card">
            <h2 class="plan-title">Current Billing Plan</h2>
            <div class="plan">
                <div class="plan__header">
                    <div class="plan__info plan-name">{{ this.currentUser.plan }}</div>
                    <VButton @clickHandler="changePlan">Change</VButton>
                    <div class="plan__price plan__lable">$0/month</div>
                    <span v-if="currentUser.plan !== 'Free'" class="plan__lable">Runs out
                        <span class="blue-text">{{ formatDateFromTimestamp(this.currentUser.activated_at, this.currentUser.renew_month) }}</span>
                    </span>
                </div>

                <div class="plan__body">
                    <div class="plan__body-item">
                        <div class="plan__lable">Max MB</div>
                        <div class="plan__info">{{ this.currentUser.max_mb }}</div>
                    </div>
                    <div class="plan__body-item">
                        <div class="plan__lable">Max Projects</div>
                        <div class="plan__info">{{ this.currentUser.max_projects }}</div>
                    </div>
                    <div class="plan__body-item">
                        <div class="plan__lable">Max Members</div>
                        <div class="plan__info">{{ this.currentUser.max_members }}</div>
                    </div>
                    <div class="plan__body-item">
                        <div class="plan__lable">Max Tasks</div>
                        <div class="plan__info">{{ this.currentUser.max_tasks }}</div>
                        <!-- If we'll implement progress bars - this is example -->
                        <!-- <div class="plan__bar">
                            <span class="plan__value value-start">0</span>
                            <div class="plan__progress-line">
                                <span class="plan__current-value">{{ this.currentUser.current_tasks }}</span>
                            </div>
                            <span class="plan__value value-end">{{ this.currentUser.max_tasks }}</span>
                        </div> -->
                    </div>
                    <div class="plan__body-item">
                        <div class="plan__lable">Max Screen Rec Time</div>
                        <div class="plan__info">{{ this.currentUser.max_record_time }} min</div>
                    </div>
                    <div v-if="currentUser.draw_images" class="plan__body-item">
                        <div class="plan__lable">Draw Images</div>
                        <div class="plan__info">{{ this.currentUser.draw_images }}</div>
                    </div>
                </div>

                <div class="plan__actions">
                    <form class="profile-form-container coupon-form" @submit.prevent="addCoupon">
                        <VLabeledGroup class="plan__lable" label="Add Coupon Code">
                            <Textfield v-model="coupon" :placeholder="'Coupon Code'" :disabled="false" />
                        </VLabeledGroup>
                        <VButton class="update-profile" @clickHandler="addCoupon" :disabled="addingCoupon" active>Add</VButton>
                    </form>
                </div>
            </div>

            <!-- <td>{{ formatDateFromTimestamp(this.currentUser.activated_at) }}</td> -->
        </div>
        
        <Flash ref="show"/>
    </div>
</template>

<script>
import VButton from "@/components/atoms/VButton.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import VLabeledGroup from "@/components/molecules/VLabeledGroup.vue";
import Flash from "@/components/Flash.vue";
import {api} from "@/mixins/axios";
import {baseURL} from "@/mixins/helpers";

export default {
    name: "Billing",
    components: { VButton, Textfield, VLabeledGroup, Flash },
    computed: {
        currentUser() {
            console.log('current user',this.$store.getters.currentUser)
            return this.$store.getters.currentUser
        }
    },
    data() {
        return {
            coupon: '',
            addingCoupon: false,
            baseURL: baseURL()
        }
    },
    methods: {
        async addCoupon() {
            if (this.addingCoupon) return
            try {
                this.addingCoupon = true
                const response = await api.post("/product_redeem", {coupon: this.coupon});
                if (response.data.msg == 'ok') {
                    this.$refs.show.showFlashSuccess('Coupon added successfully');
                    this.addingCoupon = false
                    this.searchMeUser()
                }
            } catch (e) {
            console.log(e)
            console.log(this.$parent)
                this.addingCoupon = false
                this.$parent.$parent.$refs.show.showFlashError(e.response.data.msg || 'Something went wrong');
                console.error(e);
            }
        },
        async searchMeUser() {
            try {
                const response = await api.post("/user_me", {});
                if (response.data.msg === 'ok') {
                    response.data.data.portrait = `${this.baseURL}${response.data.data.portrait}`
                    this.$store.dispatch('updateCurrentUser', response.data.data);
                }
            } catch (e) {
                console.error(e);
            }
        },
        formatDateFromTimestamp(timestamp, expires) {
            const date = new Date(timestamp * 1000);

            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            const day = date.getDate();

            if (expires) month = month + expires
            
            if (month > 12) {
                let lengthBetween = month - 12
                month = lengthBetween
            }

            const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;

            return formattedDate;
        },
        changePlan() {
            this.$parent?.$parent?.$parent?.$parent?.$refs['upgrade-modal'].showModal()
        },
        calcPercentage(current, total) {
            return Math.floor(current * 100 / total)
        },
    }
}
</script>

<style lang="scss">
.billing-wrapper {
    place-content: center;
    gap: 20px;
    .plan-card {
        padding: 20px 0 !important;
        .plan-title {
            color: #FFF;
            font-size: 30px;
            font-weight: 400;
            line-height: normal;
            margin-bottom: 5px;
        }

        .plan {
            &__header {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;
            }

            .plan-name {
                font-size: 24px;
            }

            &__info {
                color: var(--accent);
                font-size: 30px;
                font-weight: 400;
                line-height: normal;
            }

            &__lable {
                color: #DCDCDC;
                font-size: 16px;
                font-weight: 400;
                line-height: normal;
            }

            &__body {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;
                margin-top: 20px;
            }

            &__body-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;
                width: 100%;
                margin-bottom: 10px;
            }

            &__bar {
                border-radius: 10px;
                background-color: $gray-6;
                position: relative;
                height: 16px;
                width: 100%;
            }

            &__current-value {
                position: absolute;
                right: 5px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 12px;
            }

            &__value {
                position: absolute;
                top: 100%;
                font-size: 16px;

                &.value-start {
                    left: 0;
                }

                &.value-end {
                    right: 0;
                }
            }

            &__progress-line {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                background-color: $blue-5;
                border-radius: 10px;
                width: 0;
                transition: .3s width;
            }
 
            .coupon-form {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 12px 25px 0;
                gap: 8px;
                .fake-label {
                    text-align: center;
                    color: #DCDCDC;
                    font-size: 16px;
                    font-weight: 400;
                    margin-bottom: 7px;
                }
                .label {
                    margin-bottom: 0;
                }
                .textfield {
                    margin-bottom: 0;
                }
            }

            .update-profile {
                padding: 5px 16px;
            }

        }
    }
}
</style>